import { WeightBand } from '../../models/weight-milestones';

/**
 * Colours for the dashboard's weight milestone chart.
 *
 * The three band colours are the ones the farm was given for the birth weight - orange, yellow, green -
 * and they are the whole point of the chart, so they are spent on the bars and nowhere else. The
 * supporting greys are the ones the piglet registration widget already uses, so the two charts sitting
 * one above the other read as one screen.
 *
 * The API sends the band, never a colour: the thresholds behind it are backend configuration and can be
 * retuned without touching this file.
 */
export const weightMilestoneColors = {
  /** orange-500 under the lower threshold, yellow-500 between them, green-500 over the upper one. */
  band: {
    Low: '#f97316',
    Medium: '#eab308',
    High: '#22c55e'
  } as Record<WeightBand, string>,

  /** gray-400 - the threshold lines. Recessive on purpose: they are a reference, not a series. */
  threshold: '#9ca3af',

  /** gray-100 - gridlines. */
  grid: '#f3f4f6',

  /** gray-900 - value labels above the bars. */
  ink: '#111827'
};
